import * as actionType from '../actions/ActionType';
import initialState from '../store/initialState';
import {addItemAtIndex} from '../utils/Util';
import * as DateUtil from '../utils/DateUtil';

const availabilityReducer = (state = initialState.availabilityState,
    action) => {
  switch (action.type) {
    case actionType.AVAIL_RQ : {
      let property_avail = {
        ...state.properties[action.criteria.properties[0].id],
        message: action.message,
        processing: action.processing
      };

      return {
        ...state,
        message: action.message,
        properties: {...state.properties,
          [action.criteria.properties[0].id]: property_avail
        }
      }
    }
    case actionType.AVAIL_RCV : {
      let property_avail = {
        ...state.properties[action.criteria.properties[0].id],
        availability: action.availability,
        message: action.message,
        processing: action.processing
      };

      return {
        ...state,
        message: action.message,
        processing: action.processing,
        properties: {...state.properties,
          [action.criteria.properties[0].id]: property_avail
        }
      }
    }
    case actionType.AVAIL_ERR : {
      let property_avail = {
        ...state.properties[action.criteria.properties[0].id],
        availability: action.availability,
        message: action.message,
        processing: action.processing
      };

      return {
        ...state,
        message: action.message,
        processing: action.processing,
        properties: {...state.properties,
          [action.criteria.properties[0].id]: property_avail
        }
      }
    }
    case actionType.AVAIL_CRITERIA_CHANGE : {
      return {...state, criteria: action.criteria}
    }
    case actionType.AVAIL_NO_ROOMS_CHANGE : {
      if(state.criteria.roomBreakdown.length < action.noOfRooms) {
        let roomBreakdown = state.criteria.roomBreakdown.concat(Array(action.noOfRooms - state.criteria.roomBreakdown.length).fill({adults: 2, children: []}));
        let criteria = Object.assign({}, state.criteria, {roomBreakdown: roomBreakdown});
        return Object.assign({}, state, {criteria: criteria});
      }
      else {
        let roomBreakdown = state.criteria.roomBreakdown.slice(0, action.noOfRooms);
        let criteria = Object.assign({}, state.criteria, {roomBreakdown: roomBreakdown});
        return Object.assign({}, state, {criteria: criteria});
      }
    }
    case actionType.AVAIL_ROOM_CHANGE : {
      return updateRoomAtIndex(state, action.index, action.room);
    }
    case actionType.AVAIL_NO_CHILD_CHANGE : {
      let children = Object.assign([], state.criteria.roomBreakdown[action.index].children);
      let currentLength = state.criteria.roomBreakdown[action.index].children.length;
      if(currentLength < action.noOfChildren) {
        for(let i = currentLength; i < action.noOfChildren; i++) {
          children.push(0);
        }
      }
      else {
        children = children.slice(0, action.noOfChildren);
      }
      return updateRoomAtIndex(state, action.index, {...state.criteria.roomBreakdown[action.index], children: children});
    }
    case actionType.AVAIL_CHILD_AGE_CHANGE : {
      let room = Object.assign({}, state.criteria.roomBreakdown[action.roomIndex], {children: addItemAtIndex(Object.assign([], state.criteria.room_breakdown[action.roomIndex].children), action.index, action.age)});
      return updateRoomAtIndex(state, action.roomIndex, room);
    }
    case actionType.AVAIL_RANGE_CHANGE : {
      return {...state, criteria: {...action.criteria, startDate: DateUtil.localDateToString(DateUtil.localDateFromString(action.criteria.startDate).plusDays(action.days), 'yyyy-MM-dd'), endDate: DateUtil.localDateToString(DateUtil.localDateFromString(action.criteria.endDate).plusDays(action.days), 'yyyy-MM-dd')}};
    }
    case actionType.AVAIL_SHOW_RATE : {
      return {...state, showRate: action.showRate}
    }
    case actionType.AVAIL_SHOW_STATE : {
      return {...state, showState: action.showState}
    }
    case actionType.AVAIL_DISPLAY_NO_OF_NIGHTS_CHANGE : {
      return {...state, displayNoOfNights: action.displayNoOfNights}
    }
    case actionType.AVAIL_MUITHEME_CHANGE : {
      return {...state, muiTheme: action.muiTheme}
    }
    case actionType.AVAIL_CUSTOMER_KEY_CHANGE : {
      return {...state, customer_key: action.customer_key}
    }
    case actionType.AVAIL_CUSTOMER_RQ : {
      return {...state, processing: action.processing}
    }
    case actionType.AVAIL_CUSTOMER_CHANGE : {
      return {...state,
        customer: action.customer,
        token: action.token,
        showRate: !action.customer.availOnly,
        // bookable: action.customer.bookable
      }
    }
    default: {
      return state;
    }
  }
};

const updateRoomAtIndex = (state, index, room) => {
  let criteria = Object.assign({}, state.criteria, {roomBreakdown: addItemAtIndex(state.criteria.roomBreakdown, index, room)});
  return Object.assign({}, state, {criteria: criteria});
};


export default availabilityReducer


// WEBPACK FOOTER //
// ./src/reducers/availabilityReducer.js